import { render } from "./InsightResult.vue?vue&type=template&id=491ee825"
import script from "./InsightResult.vue?vue&type=script&lang=js"
export * from "./InsightResult.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__